module.exports = __webpack_public_path__ + "static/media/features-split-top-03.0a969120.png";